import { useTranslation } from 'react-i18next'
import TipsCard from './components/TipsCard'
import YearChartCard from './components/YearChartCard'
import EmployeesTableCard from './components/EmployeesTableCard'
import info from 'assets/info.svg'

const StatisticsPage = () => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-1 flex-col gap-6">
            <div className="text-[1.75rem] font-medium">
                {t('NAVIGATION_STATISTICS')}
            </div>
            <div className="flex min-h-0 flex-col gap-11 overflow-y-auto overflow-x-hidden">
                <div className="grid grid-cols-2 gap-11">
                    <TipsCard />
                    <YearChartCard />
                </div>
                <div className="grid min-h-0 grid-cols-2 gap-11">
                    <EmployeesTableCard />
                    <div className="flex items-center justify-center gap-4">
                        <img src={info} className='w-7 h-7' />
                        <div className="text-2xl font-bold">
                            {t('STATISTICS_FEES_DISCLAIMER')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticsPage
